import { MessageOutlined } from "@ant-design/icons";

export default function PlannedTrialAskVivo() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <MessageOutlined className="text-[40px] text-[#D1D5DB] mb-4" />
      <h2 className="text-[18px] font-semibold text-[#1F2933] mb-2">
        Ask Vivo
      </h2>
      <p className="text-[14px] text-[#9CA3AF] max-w-md">
        Ask Vivo will be available once this trial moves into execution and data
        sources are connected.
      </p>
    </div>
  );
}
